import { StrictMode } from 'react';
import * as ReactDOM from 'react-dom/client';
import App from './app/app';
import { environment } from './environment';
import { reloadPage } from '@partnerconnect-monorepo/shared/utils/navigation';
import { EnvironmentProvider } from '@partnerconnect-monorepo/shared/context/EnvironmentContext/EnvironmentContext';
import { Core } from '@partnerconnect-monorepo/shared/core/Core/Core';

const IS_VITE_PRELOAD_ERROR_HANDLED_SESSION_STORAGE_ITEM_NAME =
  'is-vite-preload-error-handled';

window.addEventListener('vite:preloadError', (event) => {
  event.preventDefault();

  const hasReloaded = sessionStorage.getItem(
    IS_VITE_PRELOAD_ERROR_HANDLED_SESSION_STORAGE_ITEM_NAME
  );

  if (!hasReloaded) {
    sessionStorage.setItem(
      IS_VITE_PRELOAD_ERROR_HANDLED_SESSION_STORAGE_ITEM_NAME,
      'true'
    );
    reloadPage();
  }
});

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <StrictMode>
    <EnvironmentProvider environment={environment}>
      <Core>
        <App />
      </Core>
    </EnvironmentProvider>
  </StrictMode>
);
